module.exports = __webpack_public_path__ + "h5/img/icon-money.af6f2985.png";